var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 71,
    viewBox: "0 0 77 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.87V22.68C0 10.2 10.2 0 22.68 0H76.72V48.19C76.72 60.66 66.52 70.87 54.04 70.87H0Z",
    fill: "#C7282B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6798 8.5C14.8598 8.5 8.50977 14.86 8.50977 22.67V62.36H54.0398C61.8498 62.36 68.2098 56 68.2098 48.19V8.5H22.6798Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 53.27H17.25V30.77H21.44V53.27Z",
    fill: "#C7282B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5201 45.41C42.5201 51.5 41.7101 53.45 35.3301 53.45C28.9501 53.45 28.1401 51.5 28.1401 45.41C28.1401 39.32 28.9501 37.34 35.3301 37.34C41.7101 37.34 42.5201 39.29 42.5201 45.41ZM31.8101 45.44C31.8101 49.64 32.0701 50.57 35.3301 50.57C38.5901 50.57 38.8501 49.64 38.8501 45.44C38.8501 41.24 38.5901 40.22 35.3301 40.22C32.0701 40.22 31.8101 41.18 31.8101 45.44Z",
    fill: "#C7282B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.62 53.27H51.43V34.46H45.02V30.77H62.02V34.46H55.62V53.27Z",
    fill: "#C7282B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIot);
export default __webpack_public_path__ + "static/media/logo_iot.196f4236443276cbda27684e8e0482f0.svg";
export { ForwardRef as ReactComponent };